// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Automation } from './Automation';
import {
    AutomationFromJSON,
    AutomationFromJSONTyped,
    AutomationToJSON,
    AutomationToJSONTyped,
} from './Automation';
import type { AutomationListMeta } from './AutomationListMeta';
import {
    AutomationListMetaFromJSON,
    AutomationListMetaFromJSONTyped,
    AutomationListMetaToJSON,
    AutomationListMetaToJSONTyped,
} from './AutomationListMeta';

/**
 * 
 * @export
 * @interface AutomationList
 */
export interface AutomationList {
    /**
     * 
     */
    data?: Array<Automation>;
    /**
     * 
     */
    meta?: AutomationListMeta;
}

/**
 * Check if a given object implements the AutomationList interface.
 */
export function instanceOfAutomationList(value: object): value is AutomationList {
    return true;
}

export function AutomationListFromJSON(json: any): AutomationList {
    return AutomationListFromJSONTyped(json, false);
}

export function AutomationListFromJSONTyped(json: any, ignoreDiscriminator: boolean): AutomationList {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(AutomationFromJSON)),
        'meta': json['meta'] == null ? undefined : AutomationListMetaFromJSON(json['meta']),
    };
}

export function AutomationListToJSON(json: any): AutomationList {
    return AutomationListToJSONTyped(json, false);
}

export function AutomationListToJSONTyped(value?: AutomationList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(AutomationToJSON)),
        'meta': AutomationListMetaToJSON(value['meta']),
    };
}

